module.exports = __webpack_public_path__ + "static/media/icon-clock-grey.cf2e5257.svg";